/**
 * User: n.gorte
 * Date: 06.07.2022
 * Time: 16:16
 */

import React, { useEffect, useReducer } from 'external/react';
import PropTypes from 'external/prop-types';
import { Button, Table } from 'external/react-bootstrap';

const COLLAPSE_THRESHOLD = 5;

const sqlQuery = (layers, latlng, metresPerPixel) => {
    const unionTable = layers.reduce((acc, layer, i) => {
        acc += `
        ${ layer.sql }
        ${ i < (layers.length - 1) ? ' UNION ALL ' : '' }
    `;
        return acc;
    }, '');
    const q = `
        SELECT title, topic, url, icon,
        values, ST_Distance(the_geom_webmercator, ST_Transform(ST_PointFromText('POINT(${ latlng.lng } ${ latlng.lat })', 4326), 3857)) AS distance
        FROM (${ unionTable }) as t
        WHERE ST_DWithin(t.the_geom_webmercator
            , ST_Transform(ST_PointFromText('POINT(${ latlng.lng } ${ latlng.lat })'
            , 4326)
            , 3857)
            , ${ metresPerPixel * 10 })
        ORDER BY distance
    `;
    return encodeURIComponent(q);
};

const fetchCartoFeatureInfo = ({ client, layers, latlng, metresPerPixel }) => {
    return fetch(`https://${ client.username }.carto.com/api/v2/sql?q=${ sqlQuery(layers, latlng, metresPerPixel) }&api_key=${ client.apiKey }`);
};

function reducer(state, action) {
    switch (action.type) {
        case 'SET_STATE':
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

export const CartoObjectInfoItem = ({ layerConfig, latlng, metresPerPixel }) => {
    const config = JSON.parse(layerConfig.children[ 0 ].config);
    const { client, layers } = config;
    const [ state, dispatch ] = useReducer(reducer, {
        feature: null,
        values: null,
        error: false,
        count: 0,
        collapsed: false,
    });
    const { feature, values, error, collapsed, count } = state;

    useEffect(() => {
        fetchCartoFeatureInfo({ client, layers, latlng, metresPerPixel })
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: 'SET_STATE',
                    payload: {
                        feature: data.rows[ 0 ],
                        error: false,
                    }
                });
            })
            .catch(() => {
                dispatch({
                    type: 'SET_STATE',
                    payload: {
                        feature: null,
                        error: true,
                    }
                });
            });
    }, [ latlng ]);

    useEffect(() => {
        if (feature) {
            const { values } = feature;
            try {
                if (values && values.length > 0) {
                    const valuesJson = JSON.parse(values);
                    const count = Object.keys(valuesJson).length;
                    dispatch({
                        type: 'SET_STATE',
                        payload: {
                            values: valuesJson,
                            count,
                            collapsed: count > COLLAPSE_THRESHOLD
                        }
                    });
                } else {
                    dispatch({
                        type: 'SET_STATE',
                        payload: {
                            values: null,
                            count: 0,
                            collapsed: false
                        }
                    });
                }
            } catch (e) {
                dispatch({
                    type: 'SET_STATE',
                    payload: {
                        values: null,
                        count: 0,
                        error: true,
                    }
                });
            }
        }
    }, [ feature ]);

    const toggleCollapse = () => {
        dispatch({ type: 'SET_STATE', payload: { collapsed: !collapsed } });
    };

    if (!error && !feature) {
        return null;
    }

    return (
        <li className="list-group-item leaflet-object-info__item">
            <div className="d-flex align-items-center mb-2">
                {
                    feature.icon && (
                        <img src={ feature.icon } className="leaflet-object-info__item__icon"/>
                    )
                }
                <div>
                    {
                        feature && feature.topic && feature.topic !== '' && (
                            <span className="leaflet-object-info__item__topic">
                                   { feature.topic }
                                 </span>
                        )
                    }
                    <span className="leaflet-object-info__item__title">{ feature.title || layerConfig.title }</span>
                </div>

            </div>
            {
                error && <span className="leaflet-object-info__item__error">Daten konnten nicht geladen werden.</span>
            }
            {
                !error && !values && <span className="leaflet-object-info__item__nodata">Keine weiteren Fachinformationen vorhanden.</span>
            }
            {
                !error && values && (
                    <Table striped size="sm" borderless>
                        <tbody>
                        {
                            Object.keys(values)
                                .filter((v, i) => collapsed ? i < COLLAPSE_THRESHOLD : true)
                                .map(key => {
                                    return (
                                        <tr key={ key }>
                                            <td>{ key }</td>
                                            <td>{ values[ key ] }</td>
                                        </tr>
                                    );
                                })
                        }
                        {
                            feature.url.length > 0 && (
                                <tr>
                                    <td>Url</td>
                                    <td>
                                        <a href={ feature.url } target="_blank" rel="noopener noreferrer">{ feature.url }</a>
                                    </td>
                                </tr>
                            )
                        }
                        </tbody>
                    </Table>
                )
            }

            {
                count > COLLAPSE_THRESHOLD && (
                    <div className="d-flex my-2 justify-content-end">
                        <Button
                            variant="link"
                            onClick={ toggleCollapse }
                        >
                            { collapsed ? 'Mehr ' : 'Weniger ' }
                            <span className={ `icon icon-fliwas-arrow-${ collapsed ? 'down' : 'up' }` }/>
                        </Button>
                    </div>
                )
            }


        </li>
    );
};

CartoObjectInfoItem.propTypes = {
    layerConfig: PropTypes.object,
    latlng: PropTypes.object,
    metresPerPixel: PropTypes.number,
};



// WEBPACK FOOTER //
// ./js/plugins/ExternalLayerFeatureClickPlugin/CartoObjectInfoItem.jsx